// import React, { useState, useRef, useEffect, useMemo } from 'react';
// import PropTypes from 'prop-types';
// import { Spinner, Feedback, ReferralsInfo } from 'components';
// import { USED_COUPON_STATES, COUPON_LIST_DATE_FORMAT_PATTERN } from 'coupon-common';
// import { getNormalizedEntity } from 'coupon-common/src/utils';

// // ── Dropdown options ──────────────────────────────────────────────────────────
// const DROPDOWN_OPTIONS = [
//   {
//     value: 'point_requests',
//     label: 'Point Requests',
//     icon: (
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <rect x="1" y="7" width="14" height="8" rx="1.5" stroke="#C0392B" strokeWidth="1.3"/>
//         <path d="M8 7V15" stroke="#C0392B" strokeWidth="1.3"/>
//         <path d="M1 10h14" stroke="#C0392B" strokeWidth="1.3"/>
//         <path d="M5.5 7C5.5 7 4 5 5 4C6 3 7.5 5 8 7" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
//         <path d="M10.5 7C10.5 7 12 5 11 4C10 3 8.5 5 8 7" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
//       </svg>
//     ),
//   },
//   {
//     value: 'your_referrals',
//     label: 'Your Referrals',
//     icon: (
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <circle cx="6" cy="5" r="2.5" stroke="#C0392B" strokeWidth="1.3"/>
//         <path d="M2 13c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#C0392B" strokeWidth="1.3" strokeLinecap="round"/>
//         <circle cx="12" cy="5" r="2" stroke="#C0392B" strokeWidth="1.3"/>
//         <path d="M10.5 13c0-1.4.9-2.6 2-3.2" stroke="#C0392B" strokeWidth="1.3" strokeLinecap="round"/>
//       </svg>
//     ),
//   },
//   {
//     value: 'used_coupons',
//     label: 'Used Coupons',
//     icon: (
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <path d="M2 6C2 5.45 2.45 5 3 5H13C13.55 5 14 5.45 14 6V7A1 1 0 0 1 14 9V10C14 10.55 13.55 11 13 11H3C2.45 11 2 10.55 2 10V9A1 1 0 0 1 2 7V6Z" stroke="#C0392B" strokeWidth="1.3"/>
//         <line x1="6" y1="5" x2="6" y2="11" stroke="#C0392B" strokeWidth="1" strokeDasharray="1.5 1.2"/>
//       </svg>
//     ),
//   },
//   {
//     value: 'point_transactions',
//     label: 'Point Transactions',
//     icon: (
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//         <rect x="2" y="2" width="12" height="12" rx="2" stroke="#C0392B" strokeWidth="1.3"/>
//         <line x1="5" y1="6" x2="11" y2="6" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
//         <line x1="5" y1="8.5" x2="11" y2="8.5" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
//         <line x1="5" y1="11" x2="8" y2="11" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
//       </svg>
//     ),
//   },
// ];

// const UsedCouponsStateToLabels = {
//   [USED_COUPON_STATES.WAITING]:  'Waiting',
//   [USED_COUPON_STATES.ACCEPTED]: 'Accepted',
//   [USED_COUPON_STATES.REJECTED]: 'Rejected',
//   [USED_COUPON_STATES.FAILED]:   'Failed',
//   [USED_COUPON_STATES.CANCELED]: 'Canceled',
// };

// const thStyle = {
//   padding: '14px 16px',
//   textAlign: 'left',
//   fontSize: '13px',
//   fontWeight: '500',
//   color: '#999',
//   borderBottom: '1.5px dashed #ebebeb',
//   whiteSpace: 'nowrap',
// };

// const tdStyle = isLast => ({
//   padding: '14px 16px',
//   fontSize: '14px',
//   fontWeight: '400',
//   color: '#1a1a1a',
//   borderBottom: isLast ? 'none' : '1px dashed #ebebeb',
//   whiteSpace: 'nowrap',
// });

// const emptyStyle  = { color: '#aaa', textAlign: 'center', fontSize: '13px', padding: '24px', margin: 0 };
// const loadingStyle = { textAlign: 'center', padding: '24px' };

// // ── Props mirror exactly what Dashboard3.jsx already has ──────────────────────
// const ActivityTableSection = ({
//   // from Dashboard3: pointsRequestsList (already processed useMemo)
//   pointsRequestsList,
//   // from Dashboard3: usedCouponsListState + intl (we process here to avoid new vars in Dashboard3)
//   usedCouponsListState,
//   intl,
//   onCouponClick,
//   // from Dashboard3: transactionsData, couponsData, balancesData, *DataFetched, currentUserEmail
//   transactionsData,
//   transactionsDataFetched,
//   couponsData,
//   couponsDataFetched,
//   balancesData,
//   balancesDataFetched,
//   currentUserEmail,
//   // from Dashboard3: referralData, referralFetching
//   referralData,
//   referralFetching,
// }) => {
//   const [selectedOption, setSelectedOption] = useState(DROPDOWN_OPTIONS[0]);
//   const [dropdownOpen, setDropdownOpen]     = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = e => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setDropdownOpen(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // ── Derive used coupons internally (mirrors Dashboard3 logic exactly) ────────
//   const usedCouponsEntityKey = 'usedCoupons';
//   const { entityList: usedCoupons, isFetching: isUsedCouponsFetching, error: usedCouponsError } = useMemo(() => {
//     try {
//       if (usedCouponsListState && usedCouponsEntityKey) {
//         return getNormalizedEntity(usedCouponsListState, usedCouponsEntityKey, intl, {
//           id: 'app.usedCouponsEntity',
//           defaultMessage: 'used coupons',
//         });
//       }
//     } catch (e) {}
//     return { entityList: [], isFetching: false, error: null };
//   }, [usedCouponsListState, intl]);

//   // ── Derive transactions internally (mirrors Dashboard3 processedTransactions) ─
//   const [combinedTransactions, setCombinedTransactions] = useState([]);
//   const [transactionsLoading, setTransactionsLoading]   = useState(true);

//   const processedTransactions = useMemo(() => {
//     if (!transactionsDataFetched || !couponsDataFetched || !balancesDataFetched) return null;

//     const txData = (transactionsData || []).map(tx => ({
//       ...tx,
//       id: `P${String(tx.id).padStart(4, '0')}`,
//     }));

//     const couponResults = Array.isArray(couponsData) ? couponsData : (couponsData?.results || []);
//     const couponTxData = couponResults.map(tx => ({
//       id: `C${String(tx.id).padStart(4, '0')}`,
//       time: tx.transaction_datetime,
//       amount: tx.points_delta,
//       from_user: tx.from_email?.trim() ? tx.from_email : 'ADMIN',
//       to_user: tx.to_email,
//       status: 'success',
//       notes: tx.transaction_type,
//       previous_balance: null,
//       new_balance: null,
//       from_user_name: tx.from_email?.trim() ? tx.from_user_name : 'ADMIN',
//       to_user_name: tx.to_user_name,
//     }));

//     const merged = [...txData, ...couponTxData]
//       .filter(d => d.from_user === currentUserEmail || d.to_user === currentUserEmail)
//       .sort((a, b) => new Date(b.time) - new Date(a.time));

//     let currentBalance =
//       Number((balancesData || []).find(item => item.email === currentUserEmail)?.points_at_last_date) || 0;

//     for (let i = 0; i < merged.length; i++) {
//       const tx = merged[i];
//       const amount = Number(tx.amount) || 0;
//       if (tx.to_user === currentUserEmail) {
//         tx.new_balance      = currentBalance;
//         tx.previous_balance = Number((currentBalance - amount).toFixed(2));
//         currentBalance      = tx.previous_balance;
//       } else if (tx.from_user === currentUserEmail) {
//         tx.new_balance      = currentBalance;
//         tx.previous_balance = Number((currentBalance + amount).toFixed(2));
//         currentBalance      = tx.previous_balance;
//         tx.amount           = -Math.abs(amount);
//       }
//     }
//     return merged;
//   }, [transactionsData, transactionsDataFetched, couponsData, couponsDataFetched, balancesData, balancesDataFetched, currentUserEmail]);

//   useEffect(() => {
//     if (processedTransactions) {
//       setCombinedTransactions(processedTransactions);
//       setTransactionsLoading(false);
//     }
//   }, [processedTransactions]);

//   // ── Render: Point Requests ────────────────────────────────────────────────────
//   const renderPointRequests = () => {
//     if (!pointsRequestsList || pointsRequestsList.length === 0)
//       return <p style={emptyStyle}>No points requests found.</p>;
//     const rows = pointsRequestsList.slice(0, 25);
//     return (
//       <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//         <thead>
//           <tr>
//             {['First name', 'Date and time', 'Points', 'Status'].map(h => (
//               <th key={h} style={thStyle}>{h}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {rows.map((req, i) => (
//             <tr key={req.id}>
//               <td style={tdStyle(i === rows.length - 1)}>{req.first_name}</td>
//               <td style={tdStyle(i === rows.length - 1)}>{req.date_and_time}</td>
//               <td style={tdStyle(i === rows.length - 1)}>{req.points}</td>
//               <td style={tdStyle(i === rows.length - 1)}>{req.status}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     );
//   };

//   // ── Render: Used Coupons ──────────────────────────────────────────────────────
//   const renderUsedCoupons = () => {
//     if (isUsedCouponsFetching) return <div style={loadingStyle}><Spinner show /></div>;
//     if (usedCouponsError)      return <Feedback show invalid content={usedCouponsError} />;
//     if (!usedCoupons || usedCoupons.length === 0)
//       return <p style={emptyStyle}>No used coupons found.</p>;
//     const rows = usedCoupons.slice(0, 25);
//     return (
//       <div style={{ overflowX: 'auto' }}>
//         <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '480px' }}>
//           <thead>
//             <tr>
//               {['Coupon Title', 'Customer', 'Date & Time', 'Pay By', 'Status'].map(h => (
//                 <th key={h} style={thStyle}>{h}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((coupon, i) => (
//               <tr key={coupon.id}>
//                 <td
//                   style={{ ...tdStyle(i === rows.length - 1), color: '#C0392B', cursor: 'pointer' }}
//                   onClick={() => onCouponClick && onCouponClick(coupon)}
//                 >
//                   {coupon.coupon_name}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>{coupon.customer_name}</td>
//                 <td style={tdStyle(i === rows.length - 1)}>
//                   {intl
//                     ? intl.formatDate(coupon.created_at, COUPON_LIST_DATE_FORMAT_PATTERN)
//                     : new Date(coupon.created_at).toLocaleString()}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>
//                   {coupon.pay_by_points ? 'Points' : 'Dollars'}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>
//                   {UsedCouponsStateToLabels[coupon.state] || coupon.state}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   // ── Render: Points Transactions ───────────────────────────────────────────────
//   const renderPointsTransactions = () => {
//     if (transactionsLoading) return <div style={loadingStyle}><Spinner show /></div>;
//     if (!combinedTransactions || combinedTransactions.length === 0)
//       return <p style={emptyStyle}>No transactions found.</p>;
//     const rows = combinedTransactions.slice(0, 25);
//     return (
//       <div style={{ overflowX: 'auto' }}>
//         <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
//           <thead>
//             <tr>
//               {['ID', 'Time', 'From', 'To', 'Prev Balance', 'Amount', 'New Balance', 'Status', 'Notes'].map(h => (
//                 <th key={h} style={thStyle}>{h}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((tx, i) => (
//               <tr key={tx.id}>
//                 <td style={{ ...tdStyle(i === rows.length - 1), fontFamily: 'monospace', fontSize: '12px' }}>{tx.id}</td>
//                 <td style={tdStyle(i === rows.length - 1)}>{new Date(tx.time).toLocaleString()}</td>
//                 <td style={tdStyle(i === rows.length - 1)}>
//                   {tx.from_user === currentUserEmail ? tx.from_user : tx.from_user_name}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>
//                   {tx.to_user === currentUserEmail ? tx.to_user : tx.to_user_name}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>{tx.previous_balance}</td>
//                 <td style={{
//                   ...tdStyle(i === rows.length - 1),
//                   color: tx.to_user === currentUserEmail && tx.amount > 0 ? '#16a34a' : '#dc2626',
//                   fontWeight: '600',
//                 }}>
//                   {tx.amount}
//                 </td>
//                 <td style={tdStyle(i === rows.length - 1)}>{tx.new_balance}</td>
//                 <td style={tdStyle(i === rows.length - 1)}>{tx.status}</td>
//                 <td style={tdStyle(i === rows.length - 1)}>{tx.notes}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   // ── Render: Referrals ─────────────────────────────────────────────────────────
//   const renderReferrals = () => {
//     if (referralFetching) return <div style={loadingStyle}><Spinner show /></div>;
//     const referrals = referralData?.referrals;
//     if (!referrals || referrals.length === 0)
//       return <p style={emptyStyle}>No referrals yet. Share your code to start earning!</p>;
//     return <ReferralsInfo data={referrals} />;
//   };

//   const renderTable = () => {
//     switch (selectedOption.value) {
//       case 'point_requests':     return renderPointRequests();
//       case 'used_coupons':       return renderUsedCoupons();
//       case 'point_transactions': return renderPointsTransactions();
//       case 'your_referrals':     return renderReferrals();
//       default:                   return renderPointRequests();
//     }
//   };

//   return (
//     <div style={{ background: '#f0ecec', borderRadius: '20px', padding: '16px' }}>

//       {/* ── Header ── */}
//       <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>

//         {/* Dropdown */}
//         <div ref={dropdownRef} style={{ position: 'relative' }}>
//           <button
//             onClick={() => setDropdownOpen(o => !o)}
//             style={{
//               display: 'flex', alignItems: 'center', gap: '8px',
//               padding: '9px 16px',
//               background: 'white',
//               border: '1.5px solid #e4d8d8',
//               borderRadius: '30px',
//               cursor: 'pointer',
//               minWidth: '185px',
//               justifyContent: 'space-between',
//             }}
//           >
//             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//               {selectedOption.icon}
//               <span style={{ fontSize: '14px', fontWeight: '500', color: '#2a2a2a' }}>
//                 {selectedOption.label}
//               </span>
//             </div>
//             <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
//               style={{ transition: 'transform 0.15s', transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}>
//               <path d="M3 5L7 9L11 5" stroke="#888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//             </svg>
//           </button>

//           {dropdownOpen && (
//             <div style={{
//               position: 'absolute',
//               top: 'calc(100% + 6px)',
//               left: 0,
//               background: 'white',
//               borderRadius: '14px',
//               boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
//               zIndex: 100,
//               minWidth: '210px',
//               padding: '6px 0',
//               overflow: 'hidden',
//             }}>
//               {DROPDOWN_OPTIONS.map(option => (
//                 <button
//                   key={option.value}
//                   onClick={() => { setSelectedOption(option); setDropdownOpen(false); }}
//                   style={{
//                     display: 'flex', alignItems: 'center', gap: '10px',
//                     width: '100%',
//                     padding: '11px 16px',
//                     background: selectedOption.value === option.value ? '#fff5f5' : 'transparent',
//                     border: 'none',
//                     cursor: 'pointer',
//                     fontSize: '14px',
//                     color: '#2a2a2a',
//                     textAlign: 'left',
//                   }}
//                 >
//                   {option.icon}
//                   {option.label}
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Redirect button */}
//         <button style={{
//           width: '40px', height: '40px',
//           borderRadius: '50%',
//           border: '1.5px solid #c8b4b4',
//           background: 'transparent',
//           cursor: 'pointer',
//           display: 'flex', alignItems: 'center', justifyContent: 'center',
//         }}>
//           <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//             <path d="M5 3H13V11" stroke="#8B5050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//             <path d="M13 3L3 13" stroke="#8B5050" strokeWidth="1.5" strokeLinecap="round"/>
//           </svg>
//         </button>
//       </div>

//       {/* ── Table card ── */}
//       <div style={{ background: 'white', borderRadius: '14px', overflow: 'hidden' }}>
//         {renderTable()}
//       </div>
//     </div>
//   );
// };

// ActivityTableSection.propTypes = {
//   pointsRequestsList:    PropTypes.array.isRequired,
//   usedCouponsListState:  PropTypes.object,
//   intl:                  PropTypes.object,
//   onCouponClick:         PropTypes.func,
//   transactionsData:      PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
//   transactionsDataFetched: PropTypes.bool,
//   couponsData:           PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
//   couponsDataFetched:    PropTypes.bool,
//   balancesData:          PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
//   balancesDataFetched:   PropTypes.bool,
//   currentUserEmail:      PropTypes.string,
//   referralData:          PropTypes.object,
//   referralFetching:      PropTypes.bool,
// };

// export default ActivityTableSection;

import React, { useState, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Spinner, Feedback, ReferralsInfo } from 'components';
import { USED_COUPON_STATES, COUPON_LIST_DATE_FORMAT_PATTERN } from 'coupon-common';
import { getNormalizedEntity } from 'coupon-common/src/utils';

// ── Constants ─────────────────────────────────────────────────────────────────
const PAGE_SIZE    = 5;   // rows shown initially and per "View More" click
const MAX_ROWS     = 25;  // hard cap

// ── Dropdown options ──────────────────────────────────────────────────────────
const DROPDOWN_OPTIONS = [
  {
    value: 'point_requests',
    label: 'Point Requests',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="1" y="7" width="14" height="8" rx="1.5" stroke="#C0392B" strokeWidth="1.3"/>
        <path d="M8 7V15" stroke="#C0392B" strokeWidth="1.3"/>
        <path d="M1 10h14" stroke="#C0392B" strokeWidth="1.3"/>
        <path d="M5.5 7C5.5 7 4 5 5 4C6 3 7.5 5 8 7" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
        <path d="M10.5 7C10.5 7 12 5 11 4C10 3 8.5 5 8 7" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    value: 'your_referrals',
    label: 'Your Referrals',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="6" cy="5" r="2.5" stroke="#C0392B" strokeWidth="1.3"/>
        <path d="M2 13c0-2.2 1.8-4 4-4s4 1.8 4 4" stroke="#C0392B" strokeWidth="1.3" strokeLinecap="round"/>
        <circle cx="12" cy="5" r="2" stroke="#C0392B" strokeWidth="1.3"/>
        <path d="M10.5 13c0-1.4.9-2.6 2-3.2" stroke="#C0392B" strokeWidth="1.3" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    value: 'used_coupons',
    label: 'Used Coupons',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2 6C2 5.45 2.45 5 3 5H13C13.55 5 14 5.45 14 6V7A1 1 0 0 1 14 9V10C14 10.55 13.55 11 13 11H3C2.45 11 2 10.55 2 10V9A1 1 0 0 1 2 7V6Z" stroke="#C0392B" strokeWidth="1.3"/>
        <line x1="6" y1="5" x2="6" y2="11" stroke="#C0392B" strokeWidth="1" strokeDasharray="1.5 1.2"/>
      </svg>
    ),
  },
  {
    value: 'point_transactions',
    label: 'Point Transactions',
    icon: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <rect x="2" y="2" width="12" height="12" rx="2" stroke="#C0392B" strokeWidth="1.3"/>
        <line x1="5" y1="6" x2="11" y2="6" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
        <line x1="5" y1="8.5" x2="11" y2="8.5" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
        <line x1="5" y1="11" x2="8" y2="11" stroke="#C0392B" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
  },
];

const UsedCouponsStateToLabels = {
  [USED_COUPON_STATES.WAITING]:  'Waiting',
  [USED_COUPON_STATES.ACCEPTED]: 'Accepted',
  [USED_COUPON_STATES.REJECTED]: 'Rejected',
  [USED_COUPON_STATES.FAILED]:   'Failed',
  [USED_COUPON_STATES.CANCELED]: 'Canceled',
};

const thStyle = {
  padding: '14px 16px',
  textAlign: 'left',
  fontSize: '13px',
  fontWeight: '500',
  color: '#999',
  borderBottom: '1.5px dashed #ebebeb',
  whiteSpace: 'nowrap',
};

const tdStyle = isLast => ({
  padding: '14px 16px',
  fontSize: '14px',
  fontWeight: '400',
  color: '#1a1a1a',
  borderBottom: isLast ? 'none' : '1px dashed #ebebeb',
  whiteSpace: 'nowrap',
});

const emptyStyle   = { color: '#aaa', textAlign: 'center', fontSize: '13px', padding: '24px', margin: 0 };
const loadingStyle = { textAlign: 'center', padding: '24px' };

// ── View More button ──────────────────────────────────────────────────────────
const ViewMoreButton = ({ visibleCount, totalCount, onViewMore }) => {
  const remaining = Math.min(totalCount - visibleCount, PAGE_SIZE);
  if (visibleCount >= totalCount) return null;
  return (
    <div style={{ padding: '12px 16px', borderTop: '1px dashed #ebebeb', textAlign: 'center' }}>
      <button
        onClick={onViewMore}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          padding: '8px 20px',
          background: 'transparent',
          border: '1.5px solid #C0392B',
          borderRadius: '30px',
          color: '#C0392B',
          fontSize: '13px',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        View {remaining} more
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path d="M3 5l4 4 4-4" stroke="#C0392B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
};

// ── Main component ────────────────────────────────────────────────────────────
const ActivityTableSection = ({
  pointsRequestsList,
  usedCouponsListState,
  intl,
  onCouponClick,
  transactionsData,
  transactionsDataFetched,
  couponsData,
  couponsDataFetched,
  balancesData,
  balancesDataFetched,
  currentUserEmail,
  referralData,
  referralFetching,
}) => {
  const [selectedOption, setSelectedOption] = useState(DROPDOWN_OPTIONS[2]);
  const [dropdownOpen, setDropdownOpen]     = useState(false);
  // visibleCount resets to PAGE_SIZE whenever the tab changes
  const [visibleCount, setVisibleCount]     = useState(PAGE_SIZE);
  const dropdownRef = useRef(null);

  // Reset visible rows when tab switches
  const handleSelectOption = option => {
    setSelectedOption(option);
    setDropdownOpen(false);
    setVisibleCount(PAGE_SIZE);
  };

  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ── Derive used coupons ───────────────────────────────────────────────────
  const usedCouponsEntityKey = 'usedCoupons';
  const { entityList: usedCoupons, isFetching: isUsedCouponsFetching, error: usedCouponsError } = useMemo(() => {
    try {
      if (usedCouponsListState && usedCouponsEntityKey) {
        return getNormalizedEntity(usedCouponsListState, usedCouponsEntityKey, intl, {
          id: 'app.usedCouponsEntity',
          defaultMessage: 'used coupons',
        });
      }
    } catch (e) {}
    return { entityList: [], isFetching: false, error: null };
  }, [usedCouponsListState, intl]);

  // ── Derive transactions ───────────────────────────────────────────────────
  const [combinedTransactions, setCombinedTransactions] = useState([]);
  const [transactionsLoading, setTransactionsLoading]   = useState(true);

  const processedTransactions = useMemo(() => {
    if (!transactionsDataFetched || !couponsDataFetched || !balancesDataFetched) return null;

    const txData = (transactionsData || []).map(tx => ({
      ...tx,
      id: `P${String(tx.id).padStart(4, '0')}`,
    }));

    const couponResults = Array.isArray(couponsData) ? couponsData : (couponsData?.results || []);
    const couponTxData = couponResults.map(tx => ({
      id: `C${String(tx.id).padStart(4, '0')}`,
      time: tx.transaction_datetime,
      amount: tx.points_delta,
      from_user: tx.from_email?.trim() ? tx.from_email : 'ADMIN',
      to_user: tx.to_email,
      status: 'success',
      notes: tx.transaction_type,
      previous_balance: null,
      new_balance: null,
      from_user_name: tx.from_email?.trim() ? tx.from_user_name : 'ADMIN',
      to_user_name: tx.to_user_name,
    }));

    const merged = [...txData, ...couponTxData]
      .filter(d => d.from_user === currentUserEmail || d.to_user === currentUserEmail)
      .sort((a, b) => new Date(b.time) - new Date(a.time));

    let currentBalance =
      Number((balancesData || []).find(item => item.email === currentUserEmail)?.points_at_last_date) || 0;

    for (let i = 0; i < merged.length; i++) {
      const tx     = merged[i];
      const amount = Number(tx.amount) || 0;
      if (tx.to_user === currentUserEmail) {
        tx.new_balance      = currentBalance;
        tx.previous_balance = Number((currentBalance - amount).toFixed(2));
        currentBalance      = tx.previous_balance;
      } else if (tx.from_user === currentUserEmail) {
        tx.new_balance      = currentBalance;
        tx.previous_balance = Number((currentBalance + amount).toFixed(2));
        currentBalance      = tx.previous_balance;
        tx.amount           = -Math.abs(amount);
      }
    }
    return merged;
  }, [transactionsData, transactionsDataFetched, couponsData, couponsDataFetched, balancesData, balancesDataFetched, currentUserEmail]);

  useEffect(() => {
    if (processedTransactions) {
      setCombinedTransactions(processedTransactions);
      setTransactionsLoading(false);
    }
  }, [processedTransactions]);

  // ── Render helpers ────────────────────────────────────────────────────────
  const renderPointRequests = () => {
    if (!pointsRequestsList || pointsRequestsList.length === 0)
      return <p style={emptyStyle}>No points requests found.</p>;

    const allRows  = pointsRequestsList.slice(0, MAX_ROWS);
    const rows     = allRows.slice(0, visibleCount);

    return (
      <>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['First name', 'Date and time', 'Points', 'Status'].map(h => (
                <th key={h} style={thStyle}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((req, i) => (
              <tr key={req.id}>
                <td style={tdStyle(i === rows.length - 1)}>{req.first_name}</td>
                <td style={tdStyle(i === rows.length - 1)}>{req.date_and_time}</td>
                <td style={tdStyle(i === rows.length - 1)}>{req.points}</td>
                <td style={tdStyle(i === rows.length - 1)}>{req.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <ViewMoreButton
          visibleCount={visibleCount}
          totalCount={allRows.length}
          onViewMore={() => setVisibleCount(v => Math.min(v + PAGE_SIZE, MAX_ROWS))}
        />
      </>
    );
  };

  const renderUsedCoupons = () => {
    if (isUsedCouponsFetching) return <div style={loadingStyle}><Spinner show /></div>;
    if (usedCouponsError)      return <Feedback show invalid content={usedCouponsError} />;
    if (!usedCoupons || usedCoupons.length === 0)
      return <p style={emptyStyle}>No used coupons found.</p>;

    const allRows = usedCoupons.slice(0, MAX_ROWS);
    const rows    = allRows.slice(0, visibleCount);

     return (
      <>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '480px' }}>
            <thead>
              <tr>
                {['Coupon Title', 'Customer', 'Date & Time', 'Pay By', 'Status'].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((coupon, i) => (
                <tr key={coupon.id}>
                  <td
                    style={{ ...tdStyle(i === rows.length - 1), color: '#C0392B', cursor: 'pointer' }}
                    onClick={() => onCouponClick && onCouponClick(coupon)}
                  >
                    {coupon.coupon_name}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>{coupon.customer_name}</td>
                  <td style={tdStyle(i === rows.length - 1)}>
                    {intl
                      ? intl.formatDate(coupon.created_at, COUPON_LIST_DATE_FORMAT_PATTERN)
                      : new Date(coupon.created_at).toLocaleString()}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>
                    {coupon.pay_by_points ? 'Points' : 'Dollars'}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>
                    {UsedCouponsStateToLabels[coupon.state] || coupon.state}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ViewMoreButton
          visibleCount={visibleCount}
          totalCount={allRows.length}
          onViewMore={() => setVisibleCount(v => Math.min(v + PAGE_SIZE, MAX_ROWS))}
        />
      </>
    );
  };

  const renderPointsTransactions = () => {
    if (transactionsLoading) return <div style={loadingStyle}><Spinner show /></div>;
    if (!combinedTransactions || combinedTransactions.length === 0)
      return <p style={emptyStyle}>No transactions found.</p>;

    const allRows = combinedTransactions.slice(0, MAX_ROWS);
    const rows    = allRows.slice(0, visibleCount);

    return (
      <>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
            <thead>
              <tr>
                {['ID', 'Time', 'From', 'To', 'Prev Balance', 'Amount', 'New Balance', 'Status', 'Notes'].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((tx, i) => (
                <tr key={tx.id}>
                  <td style={{ ...tdStyle(i === rows.length - 1), fontFamily: 'monospace', fontSize: '12px' }}>{tx.id}</td>
                  <td style={tdStyle(i === rows.length - 1)}>{new Date(tx.time).toLocaleString()}</td>
                  <td style={tdStyle(i === rows.length - 1)}>
                    {tx.from_user === currentUserEmail ? tx.from_user : tx.from_user_name}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>
                    {tx.to_user === currentUserEmail ? tx.to_user : tx.to_user_name}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>{tx.previous_balance}</td>
                  <td style={{
                    ...tdStyle(i === rows.length - 1),
                    color: tx.to_user === currentUserEmail && tx.amount > 0 ? '#16a34a' : '#dc2626',
                    fontWeight: '600',
                  }}>
                    {tx.amount}
                  </td>
                  <td style={tdStyle(i === rows.length - 1)}>{tx.new_balance}</td>
                  <td style={tdStyle(i === rows.length - 1)}>{tx.status}</td>
                  <td style={tdStyle(i === rows.length - 1)}>{tx.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <ViewMoreButton
          visibleCount={visibleCount}
          totalCount={allRows.length}
          onViewMore={() => setVisibleCount(v => Math.min(v + PAGE_SIZE, MAX_ROWS))}
        />
      </>
    );
  };

  const renderReferrals = () => {
    if (referralFetching) return <div style={loadingStyle}><Spinner show /></div>;
    const referrals = referralData?.referrals;
    if (!referrals || referrals.length === 0)
      return <p style={emptyStyle}>No referrals yet. Share your code to start earning!</p>;
    return <ReferralsInfo data={referrals} />;
  };

  const renderTable = () => {
    switch (selectedOption.value) {
      case 'point_requests':     return renderPointRequests();
      case 'used_coupons':       return renderUsedCoupons();
      case 'point_transactions': return renderPointsTransactions();
      case 'your_referrals':     return renderReferrals();
      default:                   return renderPointRequests();
    }
  };

  return (
    <div style={{ background: '#f0ecec', borderRadius: '20px', padding: '16px', height: '510px', display: 'flex', flexDirection: 'column' }}>

      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>

        {/* Dropdown */}
        <div ref={dropdownRef} style={{ position: 'relative' }}>
          <button
            onClick={() => setDropdownOpen(o => !o)}
            style={{
              display: 'flex', alignItems: 'center', gap: '8px',
              padding: '9px 16px',
              background: 'white',
              border: '1.5px solid #e4d8d8',
              borderRadius: '30px',
              cursor: 'pointer',
              minWidth: '185px',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {selectedOption.icon}
              <span style={{ fontSize: '14px', fontWeight: '500', color: '#2a2a2a' }}>
                {selectedOption.label}
              </span>
            </div>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
              style={{ transition: 'transform 0.15s', transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', flexShrink: 0 }}>
              <path d="M3 5L7 9L11 5" stroke="#888" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {dropdownOpen && (
            <div style={{
              position: 'absolute', top: 'calc(100% + 6px)', left: 0,
              background: 'white', borderRadius: '14px',
              boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
              zIndex: 100, minWidth: '210px',
              padding: '6px 0', overflow: 'hidden',
            }}>
              {DROPDOWN_OPTIONS.map(option => (
                <button
                  key={option.value}
                  onClick={() => handleSelectOption(option)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '10px',
                    width: '100%', padding: '11px 16px',
                    background: selectedOption.value === option.value ? '#fff5f5' : 'transparent',
                    border: 'none', cursor: 'pointer',
                    fontSize: '14px', color: '#2a2a2a', textAlign: 'left',
                  }}
                >
                  {option.icon}
                  {option.label}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Redirect button */}
        <button style={{
          width: '40px', height: '40px', borderRadius: '50%',
          border: '1.5px solid #c8b4b4', background: 'transparent',
          cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5 3H13V11" stroke="#8B5050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13 3L3 13" stroke="#8B5050" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>

      {/* ── Table card ── */}
      <div style={{ background: 'white', borderRadius: '14px', flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {renderTable()}
      </div>
    </div>
  );
};

ActivityTableSection.propTypes = {
  pointsRequestsList:      PropTypes.array.isRequired,
  usedCouponsListState:    PropTypes.object,
  intl:                    PropTypes.object,
  onCouponClick:           PropTypes.func,
  transactionsData:        PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  transactionsDataFetched: PropTypes.bool,
  couponsData:             PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  couponsDataFetched:      PropTypes.bool,
  balancesData:            PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  balancesDataFetched:     PropTypes.bool,
  currentUserEmail:        PropTypes.string,
  referralData:            PropTypes.object,
  referralFetching:        PropTypes.bool,
};

export default ActivityTableSection;